export { default } from './upload-file';
